// extracted by mini-css-extract-plugin
export default {"item":"ItemDetail_item__pVoK-","title":"ItemDetail_title__CFEiV","loadingText":"ItemDetail_loadingText__OVfhM"};